/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Plugins_LabelInputs */

const en_fc_cmp_plugins_label = /** @type {(inputs: Fc_Cmp_Plugins_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins & ecosystem`)
};

/**
* | output |
* | --- |
* | "Plugins & ecosystem" |
*
* @param {Fc_Cmp_Plugins_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_plugins_label = /** @type {((inputs?: Fc_Cmp_Plugins_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Plugins_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_plugins_label(inputs)
});
export { fc_cmp_plugins_label as "fc.cmp.plugins.label" }